import React from 'react';

const GeneratedReportsColumns: React.FC = () => {
  return (
    <div className='screening-results-columns'>
      <div
        className='screening-table-title-column'
        style={{
          borderTopLeftRadius: 'var(--radius-xl, 12px)',
          flex: '1.8',
          minWidth: '280px',
        }}
      >
        <div className='screening-table-title-column-inner'>
          <div className='screening-table-column-text'>File Name</div>
        </div>
      </div>

      <div className='screening-table-title-column' style={{ maxWidth: '160px' }}>
        <div className='screening-table-title-column-inner'>
          <div className='screening-table-column-text'>Status</div>
        </div>
      </div>

      <div className='screening-table-title-column' style={{ maxWidth: '200px' }}>
        <div className='screening-table-title-column-inner'>
          <div className='screening-table-column-text'>Created</div>
        </div>
      </div>

      <div className='screening-table-title-column' style={{ maxWidth: '220px' }}>
        <div className='screening-table-title-column-inner'>
          <div className='screening-table-column-text'>Generated By</div>
        </div>
      </div>

      <div
        className='screening-table-title-column'
        style={{ maxWidth: '120px', justifyContent: 'center' }}
      >
        <div className='screening-table-title-column-inner'>
          <div className='screening-table-column-text'>Entities</div>
        </div>
      </div>

      <div
        className='screening-table-title-column'
        style={{
          borderTopRightRadius: 'var(--radius-xl, 12px)',
          justifyContent: 'center',
          maxWidth: '160px',
        }}
      >
        <div className='screening-table-title-column-inner'>
          <div className='screening-table-column-text'>Download</div>
        </div>
      </div>
    </div>
  );
};

export default GeneratedReportsColumns;
